import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-menu-home',
  templateUrl: './skeleton-menu-home.component.html',
  styleUrls: ['./skeleton-menu-home.component.scss']
})
export class SkeletonMenuHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
